import { render, staticRenderFns } from "./ConfigSlideShowList.vue?vue&type=template&id=a0bc1f44&"
import script from "./ConfigSlideShowList.vue?vue&type=script&lang=js&"
export * from "./ConfigSlideShowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports